import { Component, OnInit } from '@angular/core';
import { ApiService } from 'app/providers/api.service';
import { Router } from '@angular/router';


@Component({
  selector: 'app-help-documents',
  templateUrl: './help-documents.component.html',
  styleUrls: ['./help-documents.component.scss']
})
export class HelpDocumentsComponent implements OnInit {
  pagesLst;
  loading=false;
  constructor(public apiSrvc: ApiService, public router: Router) { }

  ngOnInit() {
    this.getPages();
  }
  getPages(){
    console.log("in function")
    let rte=`kb/pages`;
    this.apiSrvc.get(rte).subscribe(res=>{
      console.log(res)
      this.pagesLst = res['data']
    })
  }
  gotoDocInfo(p){
    console.log("hi");
    console.log(p)
    this.router.navigate([`${p.pge_url_tx}`],{ queryParams: { pgeId: p.pge_id } });
  }
}
